import React from "react";
import { Button, Typography } from "@mui/material";
import { tss } from "tss-react";

import { Close } from "@mui/icons-material";
import commonStyles, { backgroundColor } from "styles/common";

const useStyles = tss.create({
    root: {
        position: "absolute",
        display: "table",
        backgroundColor: backgroundColor,
    },
    header: {
        position: "relative",
        height: 34,
        width: 240,
        borderRadius: "4px 4px 0 0",
        borderBottom: "solid 1px #E5E9F1",
    },
    title: {
        color: "#283C50",
        fontSize: 14,
        fontWeight: "bold",
        letterSpacing: "0.1px",
        lineHeight: "16px",
        padding: 10,
    },
    button: {
        width: 30,
        height: 30,
        minWidth: 30,
    },
});

type IProps = {
    id: string;
    name: string;
    title: string;
    handleClose: (name: string) => void;
    children?: any;
    width?: number;
    height?: number;
    className?: any;
};

export var Panel = React.forwardRef((props: IProps, ref: any) => {
    const { classes, cx } = useStyles();
    var { common } = commonStyles();
    var { id, name, title, className, children, handleClose } = props;
    if (!className) {
        className = "";
    }
    return (
        <div
            id={id}
            className={cx(classes.root, className)}
            style={{
                width: props.width ? props.width : 200,
                height: props.height ? props.height : 200,
            }}
            ref={ref}
        >
            <div className={classes.header}>
                <Typography className={classes.title}>{title}</Typography>
            </div>
            <div style={{ position: "absolute", right: 2, top: 0 }}>
                <Button
                    className={classes.button}
                    variant="text"
                    onClick={(e) => {
                        handleClose(name);
                    }}
                >
                    <Close className={common.closeButton} />
                </Button>
            </div>
            {children}
        </div>
    );
});
export default Panel;
